import styled from 'styled-components';

export const FaqSwitcherContainer = styled.div`
	position: relative;
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;

	.item {
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 10;

		width: 100%;
		padding: 3.2rem 0;

		font-size: var(--text-size);
		font-weight: 400;
		opacity: 0.8;

		border-bottom: 1px solid var(--color-line);

		cursor: pointer;

		transition: background 0.3s;

		.underline {
			position: absolute;
			bottom: 0;
			left: 0;
			z-index: 15;

			width: 100%;
			height: 1px;

			background: var(--color-primary);
		}

		&:hover {
			background: var(--color-surface);
		}

		&.active {
			color: #fff;
			font-weight: 600;
			opacity: 1;
		}
	}

	@media (max-width: 820px) {
		width: 100%;
		overflow-x: scroll;

        scroll-snap-type: x mandatory;

		.item {
			min-width: 242px;
            scroll-snap-align: center;

			&:hover {
				background: inherit;
			}

			&:active {
				background: var(--color-surface);
			}
		}
	}
`;

export default FaqSwitcherContainer;
